export const STATUS = {
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
} as const;

export const ASSET_TYPE = {
  PHOTO: 'Photo',
  VIDEO: 'Video',
} as const;
